import React, { useEffect } from "react";
import { MapContainer, TileLayer, Marker, Popup, useMap } from "react-leaflet";
import "leaflet/dist/leaflet.css";
import L from "leaflet";

import markerIconPng from "leaflet/dist/images/marker-icon.png";
import markerShadowPng from "leaflet/dist/images/marker-shadow.png";

const customIcon = new L.Icon({
  iconUrl: markerIconPng,
  shadowUrl: markerShadowPng,
  iconSize: [25, 41],
  iconAnchor: [12, 41],
});

const markers = [
  { id: 1, position: [-0.6864, 37.3757], title: "Wang'uru", count: 100 },
  { id: 2, position: [-0.6545, 37.3763], title: "Thiba", count: 80 },
  { id: 3, position: [-0.6984, 37.3466], title: "Nguka", count: 50 },
  { id: 4, position: [-0.7173, 37.3206], title: "Kagio", count: 70 },
  { id: 5, position: [-0.6911, 37.3899], title: "Murubara", count: 60 },
  { id: 6, position: [-0.6741, 37.3945], title: "Karira", count: 90 },
];

const Legend = ({ markers }) => {
  const map = useMap();

  useEffect(() => {
    const legend = L.control({ position: "bottomright" });

    legend.onAdd = function () {
      const div = L.DomUtil.create("div", "info legend p-3 bg-white shadow-lg rounded-md border border-gray-300");

      const heading = L.DomUtil.create("h4", "legend-heading text-[#111928] font-[600] text-[1rem] mb-2");
      heading.innerHTML = "Installations";
      div.appendChild(heading);
 
      markers.forEach(({ title, count }) => {
        const item = L.DomUtil.create("div", "legend-item text-xs text-gray-700 flex items-center gap-2");
        item.innerHTML = `
          <span style="background: blue; width: 10px; height: 10px; display: inline-block; border-radius: 50%;"></span> 
          ${title} <b>${count}</b>
        `;
        div.appendChild(item);
      });

      return div;
    };

    legend.addTo(map);

    return () => {
      legend.remove();
    };
  }, [map, markers]);

  return null;
};

const LeafletMap = () => {
  return (
    <div className="w-full h-auto px-5 py-3 rounded-lg bg-white shadow-md">
      <MapContainer center={[-0.6833, 37.3667]} zoom={10} className="h-[500px] w-full rounded-md">
        <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />

        {markers.map(({ id, position, title, count }) => (
          <Marker key={id} position={position} icon={customIcon}>
            <Popup>
              <b>{title}</b>
              <br />
              Projects: {count}
            </Popup>
          </Marker>
        ))}

        <Legend markers={markers} />
      </MapContainer>
    </div>
  );
};

export default LeafletMap;
